/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable import/order */
import { FC, useEffect, useState } from 'react';
import { IManageActionMenuProps } from '@bvi/admin-panel/feature/manage-list/ui/manage-action-menu/types';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { PaperModal } from 'libs/common-components/src';
import { RemoveAction } from './remove';
import { EditManageForm } from './edit-form';
import { useDeleteSubsidiaryMutation } from '@bvi/admin-panel/entities/subsidiary/api-slice';
import { useDeleteOrganizationMutation } from '@bvi/admin-panel/entities/organization/api-slice';
import { ManageBaseDataKeys } from '@bvi/api-interfaces/entity/manage-base';
import { useDeletePerpetratorMutation } from '@bvi/admin-panel/entities/perpetrator/api-slice';
import { useDeleteDefenseMutation } from '@bvi/admin-panel/entities/defense/api-slice';
import { useDeleteExceptionMutation } from '@bvi/admin-panel/entities/exception/api-slice';
import { useDeleteOrganizationTypeMutation } from '@bvi/admin-panel/entities/organization-type/api-slice';
import { useDeleteJobPositionMutation } from '@bvi/admin-panel/entities/job-position/api-slice';
import { useDeleteOrderMutation } from '@bvi/admin-panel/entities/order/api-slice';
import { useDeleteDamageMutation } from '@bvi/admin-panel/entities/damage/api-slice';
import { useDeleteCountryMutation } from '@bvi/admin-panel/entities/country/api-slice';
import { AdminPanelRoutesPaths } from '@bvi/admin-panel/shared/constants/routes';
import { getViewCasesSearchParameters } from '@bvi/admin-panel/feature/manage-list/lib/get-view-cases-search-parameters';
import { useNavigation } from '@bvi/navigation-utils';

export const ManageActionMenu: FC<IManageActionMenuProps> = ({
  id,
  type,
  detail,
  ...properties
}) => {
  const { t } = useTranslation();
  const navigate = useNavigation();
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [deleteSubsidiary] = useDeleteSubsidiaryMutation();
  const [deleteOrganization] = useDeleteOrganizationMutation();
  const [deletePerpetrator] = useDeletePerpetratorMutation();
  const [deleteDefense] = useDeleteDefenseMutation();
  const [deleteException] = useDeleteExceptionMutation();
  const [deleteOrganizationType] = useDeleteOrganizationTypeMutation();
  const [deleteJobPosition] = useDeleteJobPositionMutation();
  const [deleteOrder] = useDeleteOrderMutation();
  const [deleteDamage] = useDeleteDamageMutation();
  const [deleteCountry] = useDeleteCountryMutation();
  const handleClickOnMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleOpenModal = (type: string) => {
    if (type === t('manageList.actions.edit.caption')) {
      // Open edit modal logic
      setEditModalOpen(true);
      setModalOpen(false);
    } else if (type === t('manageList.actions.remove.caption')) {
      // Open remove modal logic
      setModalOpen(true);
      setEditModalOpen(false);
    }
  };
  const handleEditCloseModal = () => {
    setEditModalOpen(false);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const handleCloseMenu = () => {
    setAnchorElement(null);
  };
  useEffect(() => {
    if (!isEditModalOpen) {
      handleCloseMenu();
    }
  }, [isEditModalOpen]);

  const handleViewCases = () => {
    handleCloseMenu();
    navigate(
      AdminPanelRoutesPaths.CASES_LIST,
      getViewCasesSearchParameters(type, id),
    );
  };

  const handleRemove = async () => {
    if (type === ManageBaseDataKeys.SUBSIDIARIES) {
      await deleteSubsidiary(id);
    }
    if (type === ManageBaseDataKeys.ORGANIZATIONS) {
      await deleteOrganization(id);
    }
    if (type === ManageBaseDataKeys.PERPETRATORS) {
      await deletePerpetrator(id);
    }
    if (type === ManageBaseDataKeys.DEFENSES) {
      await deleteDefense(id);
    }
    if (type === ManageBaseDataKeys.EXCEPTIONS) {
      await deleteException(id);
    }
    if (type === ManageBaseDataKeys.ORGANIZATION_TYPES) {
      await deleteOrganizationType(id);
    }
    if (type === ManageBaseDataKeys.JOB_POSITIONS) {
      await deleteJobPosition(id);
    }
    if (type === ManageBaseDataKeys.ORDERS) {
      await deleteOrder(id);
    }
    if (type === ManageBaseDataKeys.DAMAGES) {
      await deleteDamage(id);
    }
    if (type === ManageBaseDataKeys.COUNTRIES) {
      await deleteCountry(id);
    }
    handleCloseModal();
  };

  return (
    <>
      <IconButton onClick={handleClickOnMenu}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorElement}
        open={Boolean(anchorElement)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleViewCases}>
          {t('manageList.actions.viewCases.caption')}
        </MenuItem>
        <MenuItem
          onClick={() => handleOpenModal(t('manageList.actions.edit.caption'))}
        >
          {t('manageList.actions.edit.caption')}
        </MenuItem>
        <RemoveAction onClick={handleRemove} />
        <PaperModal open={isEditModalOpen} onClose={handleEditCloseModal}>
          <EditManageForm
            id={id}
            type={type}
            detail={detail}
            onSuccess={handleEditCloseModal}
          />
        </PaperModal>
      </Menu>
    </>
  );
};
